var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductImgBlank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 459 459",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ph-file-text-light"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ph-file-text-light1",
    serifid: "ph-file-text-light"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ph-file-text-light2",
    serifid: "ph-file-text-light"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "ph-file-text-light3",
    serifid: "ph-file-text-light"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "tab-bar",
    serifid: "tab bar"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "ph-sign-in-light"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "ghost-btn-icon",
    serifid: "ghost btn icon"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "popup---availability",
    serifid: "popup - availability"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "ArtBoard2",
    x: 0,
    y: 0,
    width: 458.333,
    height: 458.333,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 458.333,
    height: 458.333,
    style: {
      fill: "#aae3e8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M234.119,235.942l-7.34,34.783c-0.099,0.471 -0.515,0.808 -0.996,0.808l-13.877,-0c-0.307,-0 -0.598,-0.139 -0.791,-0.378c-0.193,-0.239 -0.268,-0.552 -0.204,-0.852c-0,-0 14.856,-69.713 14.856,-69.709c6.15,-29.423 24.629,-47.012 54.219,-47.012c12.391,-0 21.84,3.675 28.203,9.599c6.409,5.966 9.712,14.225 9.712,23.418c-0,11.816 -4.69,27.236 -18.894,37.683c-9.398,6.912 -22.988,11.66 -42.204,11.66l-22.684,-0Zm2.881,-13.954l24.701,0c30.987,0 40.287,-21.194 40.287,-33.43c0,-5.751 -1.966,-10.964 -5.91,-14.734c-3.983,-3.806 -9.96,-6.126 -17.888,-6.126c-21.485,0 -33.057,15.967 -36.717,33.314l-4.473,20.976Z",
    style: {
      fill: "#0aa8bc",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.034,223.318c0.231,-1.035 -0.342,-1.33 -1.146,-1.33c-3.845,0 -9.427,0 -9.426,0c-19.168,0 -32.833,5.047 -42.208,11.943c-14.15,10.406 -18.821,25.768 -18.821,37.54c-0,9.141 2.918,15.882 8.076,21.491c5.06,5.502 12.983,11.79 33.039,11.79c11.873,-0 22.436,-4.659 28.557,-8.783c7.656,-5.158 11.275,-9.89 13.858,-14.404c0.358,-0.627 0.063,-1.353 -0.717,-1.353l-15.232,-0c-1.166,-0 -1.493,0.165 -2.012,0.582c-0.396,0.319 -2.183,2.094 -4.54,3.813c-5.204,3.795 -9.27,6.204 -19.914,6.204c-10.553,-0 -15.581,-2.605 -19.592,-6.438c-3.979,-3.802 -5.965,-9.06 -5.965,-14.861c0,-12.295 9.329,-33.608 40.465,-33.608l11.558,0c0.734,0 1.387,-0.466 1.518,-1.033c0.487,-2.107 2.015,-9.373 2.502,-11.553Z",
    style: {
      fill: "#93d2db"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductImgBlank);
export default __webpack_public_path__ + "static/media/product-img-blank.8f358e9b129e183f15ebc828f24b18a6.svg";
export { ForwardRef as ReactComponent };